import { bool, func, string } from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import PreferenceModal from '@features/trend-research/components/onboarding/components/PreferenceModal';

import {
	setDefaultSelectedPreferenceForFilter,
	setSelectedPreferenceForFilter,
	toggleBothMarketAndFabricTypes
} from '@store/actions/trend-research/TrendResearchAction';
import {
	useInsightSummary,
	useSelectedPreferences,
	useTrendResearchPreference
} from '@store/reducers/trend-research/TrendResearchReducer';

const MarketAndCategoriesFilter = ({ togglePreference, isShowPreference, getUserPreference, activeTab }) => {
	const dispatch = useDispatch();
	const summaryCounts = useInsightSummary();
	const containerRef = useRef(null);
	const preferences = useTrendResearchPreference();
	const selectedPreferences = useSelectedPreferences();
	const [showAllStyles, setShowAllStyles] = useState(false);

	useEffect(() => {
		const container = containerRef.current;
		if (container) {
			if (showAllStyles) {
				container.style.height = `${container.scrollHeight}px`;
			} else {
				container.style.height = '35px';
			}
		}
	}, [showAllStyles]);

	const toggleSelection = (id, type) => {
		dispatch(
			setSelectedPreferenceForFilter({
				preferenceType: type,
				selectedId: id
			})
		);
	};

	const isAllSelected = (preferenceType) => {
		return preferences?.[preferenceType]?.length === selectedPreferences[preferenceType].length;
	};

	const handleAllSelection = (preferenceType) => {
		const isSelected = isAllSelected(preferenceType);
		const selectedPreferenceLength = selectedPreferences[preferenceType].length;
		const preferenceLength = preferences?.[preferenceType]?.length;

		dispatch(
			setDefaultSelectedPreferenceForFilter({
				preferenceType: preferenceType,
				selectedIds: isSelected ? [] : preferences?.[preferenceType]?.map((item) => item.id),
				isResetSummary: !(
					preferenceLength === selectedPreferenceLength || selectedPreferenceLength === 0
				)
			})
		);
	};

	const handleMarketAndFabrics = () => {
		let productGroupResponseList = [];
		let fabricTypeList = [];

		const isAllProductGroupSelected = isAllSelected('productGroupResponseList');
		const isAllFabricTypeSelected = isAllSelected('fabricTypeList');

		if (isAllProductGroupSelected && isAllFabricTypeSelected) {
			productGroupResponseList = [];
			fabricTypeList = [];
		} else if (!isAllProductGroupSelected || !isAllFabricTypeSelected) {
			productGroupResponseList = preferences?.['productGroupResponseList']?.map((item) => item.id);
			fabricTypeList = preferences?.['fabricTypeList']?.map((item) => item.constant);
		}

		dispatch(
			toggleBothMarketAndFabricTypes({
				productGroupResponseList: productGroupResponseList,
				fabricTypeList: fabricTypeList,
				isResetSummary: !(
					(isAllFabricTypeSelected && isAllProductGroupSelected) ||
					(!isAllFabricTypeSelected && !isAllProductGroupSelected)
				)
			})
		);
	};

	return (
		<>
			{preferences !== null && (
				<div className="category-subcategory-button">
					<div className="category-items mb-3 d-flex flex-wrap justify-content-center align-items-center">
						<div className="navigation-tab bg-white category-tab border-0 p-0 d-flex flex-wrap justify-content-center">
							<ul>
								<li
									className={
										isAllSelected('productGroupResponseList') &&
										isAllSelected('fabricTypeList')
											? 'active'
											: ''
									}
									onClick={handleMarketAndFabrics}
								>
									{isAllSelected('productGroupResponseList') &&
									isAllSelected('fabricTypeList')
										? 'Unselect All'
										: 'Select All'}
								</li>
								{preferences?.productGroupResponseList?.map((item) => (
									<li
										className={
											selectedPreferences.productGroupResponseList.includes(item.id)
												? 'active d-flex '
												: 'd-flex'
										}
										key={`market_${item.id}`}
										onClick={() => toggleSelection(item.id, 'productGroupResponseList')}
									>
										{item.name}
										{selectedPreferences.productGroupResponseList.includes(item.id) && (
											<span>
												<img
													src={`${process.env.PUBLIC_URL}/icons/dark-check-round.svg`}
													width={20}
												/>
											</span>
										)}
									</li>
								))}
							</ul>
							<ul>
								{preferences?.fabricTypeList?.map((item) => (
									<li
										className={
											selectedPreferences.fabricTypeList.includes(item.constant)
												? 'active d-flex'
												: 'd-flex'
										}
										key={`fabric_type_${item.constant}`}
										onClick={() => toggleSelection(item.constant, 'fabricTypeList')}
									>
										{item.name}
										{selectedPreferences.fabricTypeList.includes(item.constant) && (
											<span>
												<img
													src={`${process.env.PUBLIC_URL}/icons/dark-check-round.svg`}
													width={20}
												/>
											</span>
										)}
									</li>
								))}
							</ul>
						</div>
						<div
							className="edit-perference-button cursor-pointer pt-1"
							onClick={() => togglePreference(true)}
						>
							<p className="regular-12 ">Edit Preferences</p>
						</div>
					</div>
					<div className="sub-category-tab">
						<div
							ref={containerRef}
							className={`all-sub-button d-flex flex-wrap justify-content-center ${
								showAllStyles ? 'show-all' : ''
							}`}
						>
							<div>
								<div
									className={`button size32 outline  cursor-pointer ${
										isAllSelected('categoryResponseList') ? 'active' : ''
									}`}
									onClick={() => handleAllSelection('categoryResponseList')}
								>
									{isAllSelected('categoryResponseList') ? 'Unselect All' : 'Select All'}
								</div>
							</div>
							{[...(preferences?.categoryResponseList ?? [])]
								?.sort((a, b) => a.name.localeCompare(b.name))
								?.map((item) => (
									<div
										key={`category_${item.id}`}
										onClick={() => toggleSelection(item.id, 'categoryResponseList')}
									>
										<div
											className={`button size32 outline cursor-pointer ${
												selectedPreferences.categoryResponseList.includes(item.id)
													? 'active'
													: ''
											}`}
										>
											{item.name}
										</div>
									</div>
								))}
						</div>
						<div className={`all-button-show mt-3 mb-2 ${showAllStyles ? 'active' : ''}`}>
							<p
								className="cursor-pointer gray_dark_01 regular-14 d-inline d-flex align-items-center justify-content-center"
								onClick={() => setShowAllStyles((prev) => !prev)}
							>
								<span className="pr-2">
									{showAllStyles ? 'Hide' : 'View'} All (
									{preferences.categoryResponseList?.length}){' '}
								</span>
								<span className="angel-icon">
									<img
										src={`${process.env.PUBLIC_URL}/icons/chevron_down.png`}
										width={12}
									/>
								</span>
							</p>
						</div>
					</div>
					<div className="category-result-list pb-3">
						<ul className="result-nav d-flex align-items-center">
							<li className="regular-12 gray_dark_01">
								{summaryCounts.noOfProducts}
								<span className="gray_dark_02 pl-1">Products</span>
							</li>
							<li className="regular-12 gray_dark_01">
								{activeTab === 'Brand' ? summaryCounts.noOfBrands : summaryCounts.noOfUsers}{' '}
								<span className="gray_dark_02 pl-1">Sources</span>
							</li>
							{activeTab === 'Brand' && (
								<li className="regular-12 gray_dark_01">
									{summaryCounts.noOfFabrics}{' '}
									<span className="gray_dark_02 pl-1">Fabrics</span>
								</li>
							)}
							<li className="regular-12 gray_dark_01">
								{summaryCounts.noOfColors} <span className="gray_dark_02 pl-1">Colors</span>
							</li>
							<li className="regular-12 gray_dark_01">
								{summaryCounts.noOfThemes} <span className="gray_dark_02 pl-1">Themes</span>
							</li>
							<li className="regular-12 gray_dark_01">
								{summaryCounts.noOfGraphics}{' '}
								<span className="gray_dark_02 pl-1">Graphics</span>
							</li>
							<li className="regular-12 gray_dark_01">
								{summaryCounts.noOfPrints} <span className="gray_dark_02 pl-1">Prints</span>
							</li>
						</ul>
					</div>
				</div>
			)}
			{isShowPreference && (
				<PreferenceModal
					onClose={() => togglePreference(false)}
					preferences={preferences}
					callback={getUserPreference}
				/>
			)}
		</>
	);
};

MarketAndCategoriesFilter.propTypes = {
	activeTab: string.isRequired,
	isShowPreference: bool.isRequired,
	togglePreference: func.isRequired,
	getUserPreference: func.isRequired
};

export default MarketAndCategoriesFilter;
